define([
  "jquery",
  "underscore",
  "marionette",
  "views/common/search_input_view",
], function ($, _, Marionette, SearchInput) {
  new SearchInput();

  return Marionette.View.extend({
    el: '#content_layout',

    ui: {
      'trigger': '.dropdown-container .trigger',
      'content': '.dropdown-container .content',
    },

    events: {
      'click @ui.trigger': 'toggleDropdown',
    },

    initialize: function () {
      this.bindUIElements();
    },

    toggleDropdown: function () {
      $(this.ui.trigger).toggleClass('enable');
      $(this.ui.content).toggleClass('hidden');
    },
  })
});
